import axios from "../../../common/utils/axios";
import FaqService from "../../../common/services/faq/FaqService";
export default {
    state: {
        category_questions: [],
        answer_question: "",
        questions_by_search: [],
        sidebar_visible: false,
        sidebar_selected_category: null,
        question_answer: "",
        hover: false,
        jobListings:[],
        blogs:[],
    },
    getters: {
        blogs: (state) => state.blogs,
        jobListings: (state) => state.jobListings,
        faqCategories: (state) => state.categories,
        hover: (state) => state.hover,
        question_answer: (state) => state.question_answer,
        sidebar_selected_category: (state) => state.sidebar_selected_category,
        sidebar_visible: (state) => state.sidebar_visible,
        category_questions: (state) => state.category_questions,
        answer_question: (state) => state.answer_question,
        questions_by_search: (state) => state.questions_by_search,
    },
    mutations: {
        jobListings(state, jobListings) {
            state.jobListings = jobListings;
        },
        hover(state, hover) {
            state.hover = hover;
        },
        question_answer(state, question_answer) {
            state.question_answer = question_answer;
        },
        sidebar_selected_category(state, sidebar_selected_category) {
            state.sidebar_selected_category = sidebar_selected_category;
        },
        sidebar_visible(state, sidebar_visible) {
            state.sidebar_visible = sidebar_visible;
        },
        category_questions(state, category_questions) {
            state.category_questions = category_questions;
        },
        answer_question(state, answer_question) {
            state.answer_question = answer_question;
        },
        questions_by_search(state, questions_by_search) {
            state.questions_by_search = questions_by_search;
        },
        getBlogs(state, data) {
            state.blogs = data;
        },
    },
    actions: {
        getQuestionCategories: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "question_categories/getCategoryQuestions",
                        method: "get",
                        authorization: false,
                    })
                    .then((response) => {
                        commit("category_questions", response.data.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        getQuestionAnswer: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "answer_questions/getQuestionAnswer",
                        method: "post",
                        data: data,
                    })
                    .then((response) => {
                        commit("answer_question", response.data.data);
                        resolve(response);
                        return response.data.data;
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        getAllQuestions: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "questions",
                        method: "get",
                    })
                    .then((response) => {
                        commit("sidebar_selected_category", response.data.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        getQuestionsBySearch: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "answer_questions/getQuestionsBySearch",
                        method: "post",
                        data: data,
                    })
                    .then((response) => {
                        commit("questions_by_search", response.data.data);
                        resolve(response);
                        return response.data.data;
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        getJobListings: async (context, data) => {
            var faqService = new FaqService();
            var result =  await faqService.allJobs();
            context.commit('jobListings', result.data.data)
            return result
        },
        getBlogs: async (context, data) => {
            var faqService = new FaqService();
            var result =  await faqService.allBlogs();
            context.commit('getBlogs', result.data.data)
            return result
        },
        applyToJob: async (context, data)=>{
            var faqService = new FaqService();
            data.phone_number = data.phone_dial + " " + data.phone_number
            var result =  await faqService.applyToJob(data);
            return result
        },
    },
};